
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/politika-obrabotki-dannyh",
      function () {
        return require("private-next-pages/politika-obrabotki-dannyh.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/politika-obrabotki-dannyh"])
      });
    }
  